<div class="flex flex-col gap-md">
  <sb-support-text-block
    [title]="'Remote Support' | translate"
    [body]="'We use AnyDesk to view your screen during support calls. Download it here.' | translate"
  />
  <div class="flex gap-sm">
    <a sb-button [color]="'secondary'" href="https://get.anydesk.com/GB7G1JSe/AnyDesk.dmg" target="_blank">{{
      'Mac' | translate
    }}</a>

    <a sb-button [color]="'secondary'" href="https://get.anydesk.com/Kmh1RVaZ/AnyDesk.exe" target="_blank">{{
      'Windows' | translate
    }}</a>
  </div>
</div>
